import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const JiraIntegration = React.lazy(() => import("./JiraIntegration"));

interface JiraIntegrationProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function JiraIntegrationLazy(props: JiraIntegrationProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <JiraIntegration {...props} />
    </Suspense>
  );
}
